<div class="table-responsive" *ngIf="irsaliyeKalemler">
  <table class="table card-table table-vcenter datatable">
    <thead>
      <tr>
        <th>Tarih</th>
        <th>İrsaliye No</th>
        <th>Cari</th>
        <th>Taşımacı</th>
        <th>Stok Kodu</th>
        <th>Stok Adı</th>
        <th>İrsaliye Miktar</th>
        <th>Kabul Miktar</th>
        <th>Fazla Miktar</th>
        <th>Red Miktar</th>
        <th>Eksik Miktar</th>
        <th>Onaylanan Miktar</th>
        <th>Durum</th>
        <th>Açıklama</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let t of irsaliyeKalemler">
        <td>{{t.tarih | date: 'dd.MM.yyyy'}}</td>
        <td>{{t.irsaliyeNo}}</td>
        <td>{{t.cari}}</td>
        <td>{{t.tasimaci}}</td>
        <td>{{t.stokKodu}}</td>
        <td>{{t.stokAdi}}</td>
        <td>{{t.irsaliyeMiktar}}</td>
        <td>{{t.fazlaMiktar}}</td>
        <td>{{t.kabulMiktar}}</td>
        <td>{{t.redMiktar}}</td>
        <td>{{t.eksikMiktar}}</td>
        <td><input type="number" class="form-control w-6" [(ngModel)]="t.onaylananMiktar"></td>
        <td>
          <select class="form-control w-6" [(ngModel)]="t.durum" [ngModelOptions]="{standalone: true}">
            <option [value]=null selected></option>
            <option [ngValue]=0>Red</option>
            <option [ngValue]=1>Kabul</option>
          </select>
        </td>
        <td><input type="text" class="form-control" [(ngModel)]="t.aciklama"></td>
        <td class="text-right">
          <div class="btn btn-sm btn-success" (click)="kaydet(t)">Kaydet</div>
        </td>
      </tr>
    </tbody>
  </table>
</div>